var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPricingBenefit3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_36517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2051 20.0083C15.7184 20.0083 20.2051 15.5216 20.2051 10.0083C20.2051 4.49498 15.7185 0.00830078 10.2051 0.00830078C4.6917 0.00830078 0.205078 4.49498 0.205078 10.0083C0.205078 15.5216 4.69175 20.0083 10.2051 20.0083ZM10.2051 1.34161C14.9851 1.34161 18.8718 5.22826 18.8718 10.0083C18.8718 14.7883 14.9851 18.675 10.2051 18.675C5.42504 18.675 1.53839 14.7883 1.53839 10.0083C1.53839 5.22826 5.4251 1.34161 10.2051 1.34161Z",
    fill: "#00CC61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1204 13.195C13.2438 13.2949 13.3904 13.3416 13.5371 13.3416C13.7338 13.3416 13.9271 13.255 14.0571 13.0917C14.2871 12.805 14.2404 12.385 13.9538 12.155L10.8704 9.68829V4.67496C10.8704 4.30828 10.5704 4.0083 10.2038 4.0083C9.83709 4.0083 9.53711 4.30828 9.53711 4.67496V10.0083C9.53711 10.2117 9.63046 10.4016 9.78711 10.5283L13.1204 13.195Z",
    fill: "#00CC61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_36517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.205078 0.00830078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPricingBenefit3);
export default __webpack_public_path__ + "static/media/icon-pricing-benefit-3.5c936b54d8026e4b31741dedce7e9f11.svg";
export { ForwardRef as ReactComponent };